export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  logoutUrl: process.env.REACT_APP_AUTH0_LOGOUT_URL
}



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js